import { Typography, Col, Checkbox, Flex, Grid, Input } from "antd";
import InputNumberField from "../Input/InputNumber";
import ChequePayment from "../Payment/ChequePayment";
import EmiPayment from "../Payment/EmiPayment";
import { returnCalculateTotals } from "../../utils/sales_return";
import NormalPayment from "../Payment/NormalPayment";
import AddExpensesSection from "../../pages/ProductReplace/components/AddExpenses";
import { getCurrencySymbol } from "../../lib/currency";
const { Text } = Typography;
const { useBreakpoint } = Grid;

const ReturnDataTableFooter = ({
  footerValues,
  taxMode,
  onFooterChange,
  dataSource,
  defaultAccount,
  pageType,
  authInfo,
}) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md || !screens.xl; // Adjust the breakpoint as per requirement
  const { dueAmount, grandTotal, totalSubtotal } = returnCalculateTotals(
    dataSource,
    footerValues
  );

  const symbol = getCurrencySymbol(authInfo?.currency);

  return (
    <Flex
      gap={10}
      style={{
        width: "100%",
        flexDirection: isMobile ? "column-reverse" : "row",
      }}
    >
      <Flex
        vertical
        gap={50}
        style={{
          width: isMobile ? "100%" : "50%",
        }}
      >
        <>
          {
            // <NormalPayment
            //   onFooterChange={onFooterChange}
            //   value={footerValues.payCart}
            //   defaultAccount={defaultAccount}
            //   pageType={pageType}
            // />
            <ChequePayment
              footerValues={footerValues}
              onFooterChange={onFooterChange}
              defaultAccount={defaultAccount}
              pageType={pageType}
            />
          }
          {footerValues?.paymentMode?.includes("isCheque") ||
            (pageType !== "salesReturn" && (
              <ChequePayment
                footerValues={footerValues}
                onFooterChange={onFooterChange}
                defaultAccount={defaultAccount}
                pageType={pageType}
              />
            ))}
          {footerValues?.paymentMode?.includes("isEmi") &&
            pageType !== "salesReturn" && (
              <EmiPayment
                onFooterChange={onFooterChange}
                salesVoucherNumber={footerValues?.salesVoucherNumber}
              />
            )}
        </>
        <Flex
          style={{
            marginTop: "32px",
            marginBottom: "32px",
          }}
        >
          <Col
            style={{
              width: "100%",
            }}
          >
            {pageType !== "salesReturn" && (
              <Checkbox.Group
                onChange={(value) => onFooterChange(value, "paymentMode")}
                options={[
                  {
                    label: "Is Payment EMI System?",
                    value: "isEmi",
                  },
                  {
                    label: "Is Cheque?",
                    value: "isCheque",
                  },
                ]}
              />
            )}
            {pageType !== "salesReturn" && <AddExpensesSection />}
          </Col>
        </Flex>
      </Flex>
      <Flex
        gap={10}
        vertical
        style={{
          width: isMobile ? "100%" : "50%",
        }}
      >
        <Flex justify="space-between" align="center" gap={60}>
          <Col
            style={{
              width: "50%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              Subtotal :
            </Text>
          </Col>
          <Col
            style={{
              width: "19%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              {symbol}
              {totalSubtotal?.toFixed(2)}
            </Text>
          </Col>
        </Flex>
        {taxMode === "on_total" && (
          <>
            <Flex justify="space-between" align="center" gap={50}>
              <Col
                style={{
                  width: "50%",
                }}
              >
                <Text
                  level={5}
                  style={
                    {
                      // fontWeight: 500,
                    }
                  }
                >
                  Discount :
                </Text>
              </Col>
              <Col
                style={{
                  width: "19%",
                }}
              >
                <InputNumberField
                  min={0}
                  max={100}
                  type="number"
                  value={footerValues.discountPercent}
                  onChange={(value) => onFooterChange(value, "discountPercent")}
                  suffix="%"
                  style={{ width: "100%" }}
                />
              </Col>
            </Flex>
            <Flex justify="space-between" align="center" gap={50}>
              <Col
                style={{
                  width: "50%",
                }}
              >
                <Text
                  level={5}
                  style={
                    {
                      // fontWeight: 500,
                    }
                  }
                >
                  Vat :
                </Text>
              </Col>
              <Col
                style={{
                  width: "19%",
                }}
              >
                <InputNumberField
                  min={0}
                  max={100}
                  value={footerValues.taxPercent}
                  onChange={(value) => onFooterChange(value, "taxPercent")}
                  suffix="%"
                  style={{ width: "100%" }}
                />
              </Col>
            </Flex>
          </>
        )}

        {pageType !== "salesReturn" && (
          <Flex justify="space-between" align="center" gap={50}>
            <Col
              style={{
                width: "50%",
              }}
            >
              <Text
                level={5}
                style={
                  {
                    // fontWeight: 500,
                  }
                }
              >
                Service Charge :
              </Text>
            </Col>

            <Col
              style={{
                width: "19%",
              }}
            >
              <InputNumberField
                min={0}
                value={footerValues?.serviceCharge}
                onChange={(value) => onFooterChange(value, "serviceCharge")}
                style={{ width: "100%" }}
              />
            </Col>
          </Flex>
        )}
        <Flex justify="space-between" align="center" gap={50}>
          <Col
            style={{
              width: "50%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              Grand Total :
            </Text>
          </Col>
          <Col
            style={{
              width: "19%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              {symbol}
              {(grandTotal || 0)?.toFixed(2)}
            </Text>
          </Col>
        </Flex>
        {pageType !== "salesReturn" && (
          <Flex justify="space-between" align="center" gap={50}>
            <Col
              style={{
                width: "50%",
              }}
            >
              <Text
                level={5}
                style={
                  {
                    // fontWeight: 500,
                  }
                }
              >
                Paid Amount :
              </Text>
            </Col>
            <Col
              style={{
                width: "19%",
              }}
            >
              <InputNumberField
                min={0}
                precision={2}
                value={(footerValues?.paidAmount || 0)?.toFixed(2)}
                onChange={(value) => {
                  onFooterChange(value, "paidAmount");
                  // ⚡ mark as manually edited
                  footerValues.isPaidAmountEdited = true;
                }}
                style={{ width: "100%" }}
                disabled
              />
            </Col>
          </Flex>
        )}
        {pageType !== "salesReturn" && (
          <Flex justify="space-between" align="center" gap={50}>
            <Col
              style={{
                width: "50%",
              }}
            >
              <Text
                level={5}
                style={
                  {
                    // fontWeight: 500,
                  }
                }
              >
                Due Amount :
              </Text>
            </Col>
            <Col
              style={{
                width: "19%",
              }}
            >
              <Text
                level={5}
                style={
                  {
                    // fontWeight: 500,
                  }
                }
              >
                {symbol}
                {(dueAmount || 0)?.toFixed(2)}
              </Text>
            </Col>
          </Flex>
        )}
        <Flex justify="space-between" align="center" gap={50}>
          <Col
            style={{
              width: "100%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              Description
            </Text>
            <Input.TextArea
              value={footerValues?.description}
              onChange={(e) => {
                onFooterChange(e.target.value, "description");
              }}
              Flexs={2}
              style={{ width: "100%" }}
            />
          </Col>
        </Flex>
        {/* <Flex>
          <Col
            style={{
              width: "100%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              Challan Text
            </Text>
            <Input.TextArea
              value={footerValues?.challanText}
              onChange={(e) => onFooterChange(e.target.value, "challanText")}
              rows={2}
              style={{ width: "100%" }}
            />
          </Col>
        </Flex> */}
      </Flex>
    </Flex>
  );
};

export default ReturnDataTableFooter;
